import { tabs as tabsTypes } from './types'

const setActiveTabId = id => ({
  type: tabsTypes.setActiveTabId,
  payload: { id },
})

export { setActiveTabId }
